import docFlowApi from '@/api/eDocInternal/docFlow'
import { TASK_LIST_JOB_TYPE, EDOC_SORT_PROP } from '@/constant/constant'

const state = {
  processData: {},
  taskListJobType: 0,
  currentGid: 0,
  currentFollowedEuid: null,
  inflowStatus: [],
  docFlowType: null, // docFlow Type
  listLoading: false, // for showing loading animation when get data from server
  onlyShowPrefilled: false, // only show prefilled suggestion and receivers. For finishing process in batch
  filterText: '', // for searching document
  pageNum: 1,
  pageSize: 10,
  orderingProp: EDOC_SORT_PROP.RECEIVE_DATE,
  openerList: [] // users who can open encrypted edocx
  // redirectPath: null
}

const actions = {

  async getProcessList ({ commit, state }, payload) {
    commit('setProcessData', {}) // clear cache
    commit('setListLoading', true)
    if (state.taskListJobType === TASK_LIST_JOB_TYPE.MY_JOB) {
      await docFlowApi.getProcessList(payload.pageNum, payload.pageSize, payload.status, state.inflowStatus, payload.keyword, state.docFlowType, payload.isContainPrefilledInsOnly, payload.orderByKey, payload.isContainPrefilledReceiverOnly, resp => {
        commit('setProcessData', resp.data)
      })
    } else if (state.taskListJobType === TASK_LIST_JOB_TYPE.GROUP_JOB) {
      await docFlowApi.getProcessListByGroup(payload.pageNum, payload.pageSize, payload.status, state.inflowStatus, payload.keyword, state.currentGid, state.docFlowType, payload.isContainPrefilledInsOnly, payload.orderByKey, payload.isContainPrefilledReceiverOnly, resp => {
        commit('setProcessData', resp.data)
      })
    } else {
      await docFlowApi.getProcessListByFollow(payload.pageNum, payload.pageSize, payload.status, state.inflowStatus, payload.keyword, state.currentFollowedEuid, state.docFlowType, payload.isContainPrefilledInsOnly, payload.orderByKey, resp => {
        commit('setProcessData', resp.data)
      })
    }
    commit('setListLoading', false)
  },

  async getOpenerList ({ commit, state }, processId) {
    await docFlowApi.getDfDocumentOpenerList(processId, resp => {
      if (resp.status === 200 || resp.status === 201) {
        commit('setOpenerList', resp.data)
      } else {
        commit('setOpenerList', [])
      }
    })
  }

  // async getCompletedInflow ({ commit, state }, payload) {
  //   await docFlowApi.getCompletedInflow(state.pageNo, state.pageSize, payload.keyword, resp => {
  //     commit('setCompletedInflowData', resp.data)
  //   })
  // },

  // async getCompletedProcess ({ commit, state }, payload) {
  //   await docFlowApi.getCompletedProcess(payload.inflowId, resp => {
  //     commit('setCompletedProcessData', resp.data)
  //   })
  // }

}

const mutations = {
  setProcessData (state, data) {
    state.processData = data
  },

  setTaskListJobType (state, type) {
    state.taskListJobType = type
  },

  setCurrentGid (state, val) {
    state.currentGid = val
  },

  setCurrentFollowedEuid (state, val) {
    state.currentFollowedEuid = val
  },

  setInflowStatus (state, val) {
    state.inflowStatus = val
  },

  setDocFlowType (state, val) {
    state.docFlowType = val
  },

  setListLoading (state, val) {
    state.listLoading = val
  },

  setOnlyShowPrefilled (state, val) {
    state.onlyShowPrefilled = val
  },

  setFilterText (state, val) {
    state.filterText = val
  },

  setPageNum (state, val) {
    state.pageNum = val
  },

  setPageSize (state, val) {
    state.pageSize = val
  },

  setOrderingProp (state, val) {
    state.orderingProp = val
  },

  setOpenerList (state, val) {
    state.openerList = val
  }

  // setRedirectPath (state, val) {
  //   state.redirectPath = val
  // }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
